import { useLocalStorage } from "@elit-hair/elit-tools";
import { Button } from "@mui/material";
import { ReactNode, useCallback, useState } from "react";
import { ErrorBoundary as ErrorBoundaryWrapper } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { TbBugFilled } from "react-icons/tb";

import { useSendError } from "@/requests/report.mutations";

export const ErrorBoundary = ({ children }: { children: ReactNode }) => {
    const { mutateAsync: sendError } = useSendError();

    const { t } = useTranslation();
    const [lastError, setLastError] = useLocalStorage("lastError", "");
    const [allowResetApp, setAllowResetApp] = useState(false);

    const renderErrorScreen = useCallback(() => {
        return (
            <div className="h-full w-full bg-elitDarkBlue flex flex-col gap-4 justify-center items-center text-white">
                <TbBugFilled size={100} />
                <div className="text-center">
                    <h2 className="mb-0">{t("error-ocurred")}</h2>
                    <div className="m-0">{t("developer-team-notified")}</div>
                </div>

                <Button
                    onClick={() => {
                        location.href = "/";
                    }}
                    color="secondary"
                    variant="outlined"
                >
                    {t("back-to-home")}
                </Button>

                {allowResetApp && (
                    <Button
                        onClick={() => {
                            localStorage.clear();
                            location.href = "/";
                        }}
                        color="error"
                        variant="text"
                    >
                        {t("remove-local-data")}
                    </Button>
                )}
            </div>
        );
    }, [t, allowResetApp]);

    return (
        <ErrorBoundaryWrapper
            fallbackRender={renderErrorScreen}
            onError={(error) => {
                if (lastError === error.message) setAllowResetApp(true);
                setLastError(error.message);

                sendError([error.name, error.message, error.stack]);
                console.error(error);
            }}
        >
            {children}
        </ErrorBoundaryWrapper>
    );
};
